import Link from '../../views/Approve';
import { connect } from 'react-redux';
import { actions } from '../../../state/assessment';
import {push} from "connected-react-router";

const mapStateToProps = (state, ownProps) => ({
  intel: ownProps.match.params.intel,
  locale: ownProps.match.params.locale,
  status: state.shift.status,
  nextaction: state.shift.assessment.nextaction,
  popwindow: state.shift.status.popwindow,
  username: state.shift.auth.username,
  usersapproveList: state.shift.assessment.usersapproveList,
  role: state.shift.auth.role,
});
const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;
  return {
    getusersList: username => {
      dispatch(actions.usersapproveList());
    },

    inviteUser: (firstName, lastName, email, phoneNumber,adminUsername,role,fun) =>{
      dispatch(actions.register(firstName, lastName, email, phoneNumber,adminUsername,role)).then(()=>fun());
    },

    deleteUser: (username, email, adminUsername,props,selectItem) =>{
      dispatch(actions.unregister(username, email, adminUsername)).then(
        setTimeout(() => {
          window.location.reload()();
        }, 1000)
      )
    },
    clickBackHandler: value => {
      dispatch(push(`/${locale}/shift`));
    },
    reactiveUser: (username, email, adminUsername,props,selectItem) =>{
      dispatch(actions.reactiveUser(username, email, adminUsername)).then(
        setTimeout(() => {
          // selectItem({});
          // win.getusersList(username)
          window.location.reload()();
        }, 1000)
      )
    },
  }
};

const ApproveUser = connect(
  mapStateToProps,
  mapDispatchToProps
)(Link);

export default ApproveUser;



// WEBPACK FOOTER //
// ./src/components/container/Approve/index.js